import store from '../store'

export const findQuestionById = (id) => {
  return findQuestionByIdAux(store.getState().questions, id)
}

const findQuestionByIdAux = (questions, id) => {
  let targetQuestion = undefined
  for (const question of questions) {
    // If the id matches we have found the question and can exit
    if (question.id === id) {
      targetQuestion = question
      break
    }
    // Otherwise, if the question is expandable and contains more questions
    // we traverse into the subtree of questions
    if (question.type === 'expandable') {
      targetQuestion = findQuestionByIdAux(question.content, id)
      if (targetQuestion) break
    }
  }

  return targetQuestion
}
